import { api } from '@/api/client';

export interface TrashNoteItem {
  id: string;
  title: string;
  deleted_at: string;
}

export interface TrashCredentialItem {
  id: string;
  title: string;
  type: string;
  deleted_at: string;
}

export interface TrashList {
  notes: TrashNoteItem[];
  credentials: TrashCredentialItem[];
}

export interface RestoreResponse {
  id: string;
  type: 'note' | 'credential';
  new_title: string;
}

export const trashApi = {
  list: (tenantId: string) => api.get<TrashList>(`/tenants/${tenantId}/trash`),
  restoreNote: (id: string) =>
    api.post<RestoreResponse>(`/trash/note/${id}/restore`),
  restoreCredential: (id: string) =>
    api.post<RestoreResponse>(`/trash/credential/${id}/restore`),
};
